export default Object.freeze({
 
  version_text: "Version 1.2.0",
  copyright_text_01: "©2022 Nikon Corporation.",
  copyright_text_02: "©2022 Nikon Solutions Co.,Ltd.",
  appStore: "https://apps.apple.com/jp/app/6448491559",
  playStore: "https://play.google.com/store/apps/details?id=com.nikon.nilimo",
  search_text_placeholder_number: "耳標・拡大４桁",
  search_text_placeholder_name: "名前",
  maxLength: 128, // 入力最大文字列長
  number_maxLength: 4, // 耳標・拡大４桁の文字列長
  pregnancy_term: 280,
  password_reg: "^[\x20-\x7F]*$",
  password_error: "パスワードは、半角の英数字と特殊文字で入力してください。",
  user_error_message: "ユーザーが存在しません。ログアウトします。",
  relogin_message: "長時間ログイン状態が続いたため、再度ログインしてください。",
  usertype_message: "ユーザーの権限が変更されたため、再度ログインしてください。",
  number_error_message: "個体識別番号は、10桁半角数値で入力してください。",
  fnumber_error_message: "父牛個体識別番号は、10桁半角数値で入力してください。",
  mnumber_error_message: "母牛個体識別番号は、10桁半角数値で入力してください。",
  unknown_error_message: "不明なエラーが発生しました。再ログインしてください。",
  alert_message: [
    { message_text: '羊膜が出ていそうです', alert_index: 0 },
    { message_text: 'やぶれた羊膜が出ていそうです', alert_index: 1 },
    { message_text: '子牛の足が出ていそうです', alert_index: 2 },
    { message_text: 'しっぽが上がっていそうです', alert_index: 3 },
    { message_text: '歩数が増えていそうです', alert_index: 4 },
    { message_text: '足蹴りをしていそうです', alert_index: 5 },
    { message_text: '餌を食べる量が減っていそうです', alert_index: 6 },
    { message_text: '立ち座りの回数が増えていそうです', alert_index: 7 },
    { message_text: '旋回が増えていそうです', alert_index: 8 },
    { message_text: '初乳を飲んでいそうです', alert_index: 100 },
    { message_text: '子牛の運動量が減っていそうです', alert_index: 101 },
    { message_text: '子牛が誕生したようです', alert_index: 102 }
  ],
  editDisableAlerts: [4, 6, 7, 8, 101],
  cancelMessage: "\n※出産兆候と子牛の運動量減少と保護中のイベントは対象外となります。",
  cancelProtectMessage: "\n※出産兆候と子牛の運動量減少と保護中のイベントは対象外となります。",
  protectMessage: "\n※出産兆候と子牛の運動量減少と保護中のイベントは対象外となります。",
  deleteProtectMessage: "\n※保護中のイベントは対象外となります。",
  cows_per_page: 100,  // 牛データの件数/ページサイズ
  cow_sort_key: [2, 3, 1, 0, 4],   // 牛管理一覧表示のソート条件とget_sort_cowsのソートキーの変換テーブル
  cow_kinds: ['黒毛和牛', 'ホルスタイン', 'F1', '赤牛', '未選択'],
  cow_sexs: ['メス', 'オス', '未選択'],
  cow_status_kinds: ["成牛", "子牛", "出荷", "死亡・廃用", '未選択'],
  cow_status_select: [
                      {id:"0", kind:"成牛"},
                      {id:"1", kind:"子牛"},
                      {id:"2", kind:"出荷"},
                      {id:"3", kind:"死亡・廃用"}
                    ],
  cow_kinds_select: [
                      {id:"0", kind:"黒毛和牛"},
                      {id:"1", kind:"ホルスタイン"},
                      {id:"2", kind:"F1"},
                      {id:"3", kind:"赤牛"}
                    ],
  cow_sexs_select: [
                      {id:"0", kind:"メス"},
                      {id:"1", kind:"オス"}
                    ],
  cow_amnions_select: [
                      {id:"0", kind:"する"},
                      {id:"1", kind:"しない"}
                    ],
  cow_birth_select: [
                      {id:"0", kind:"出産"},
                      {id:"1", kind:"死産・流産"}
                    ],
  cow_pregnancy_select: [
                      {id:"0", kind:"妊娠した"},
                      {id:"1", kind:"妊娠しなかった"}
                    ],
  select_days: [
    {id:"1", day:"1日"},
    {id:"2", day:"2日"},
    {id:"3", day:"3日"},
    {id:"4", day:"4日"},
    {id:"5", day:"5日"},
    {id:"6", day:"6日"},
    {id:"7", day:"7日"}
  ],
  select_times: [
    {id:5, kind:"5分"},
    {id:10, kind:"10分"},
    {id:15, kind:"15分"},
    {id:20, kind:"20分"},
    {id:30, kind:"30分"},
    {id:45, kind:"45分"},
    {id:60, kind:"1時間"},
    {id:120, kind:"2時間"},
    {id:180, kind:"3時間"}
  ],
  user_kinds_select: [
    {id:0, kind:"管理者"},
    {id:1, kind:"協力者"},
    {id:2, kind:"獣医"},
    {id:3, kind:"デモユーザー"}
  ],
  user_kinds: ["管理者", "協力者", "獣医", "デモユーザー"],
  disable_user_kind: 2 // この値以上はメニュー制限ユーザー（獣医、デモユーザー）
});